import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const SocialMediaMarketing = () => {
  const service = getDigitalMarketingService('social-media-marketing');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default SocialMediaMarketing;
